import { render, staticRenderFns } from "./ImgUpload.vue?vue&type=template&id=0a212cb4&scoped=true&"
import script from "./ImgUpload.vue?vue&type=script&lang=js&"
export * from "./ImgUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImgUpload.vue?vue&type=style&index=0&id=0a212cb4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a212cb4",
  null
  
)

export default component.exports